import(/* webpackMode: "eager" */ "/app/src/app/courses/error.tsx");
